import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";
import "@/App.css";

import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import Dashboard from "@/pages/Dashboard";
import GeneratorPage from "@/pages/GeneratorPage";
import ProjectDetail from "@/pages/ProjectDetail";
import PricingPage from "@/pages/PricingPage";
import PaymentResult from "@/pages/PaymentResult";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-gray-400">Chargement…</div>;
  if (!user) return <Navigate to="/connexion" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster theme="dark" position="top-right" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/connexion" element={<AuthPage mode="login" />} />
            <Route path="/inscription" element={<AuthPage mode="register" />} />
            <Route path="/tarifs" element={<PricingPage />} />
            <Route path="/tableau-de-bord" element={<Protected><Dashboard /></Protected>} />
            <Route path="/generer" element={<Protected><GeneratorPage /></Protected>} />
            <Route path="/projet/:id" element={<Protected><ProjectDetail /></Protected>} />
            <Route path="/paiement/succes" element={<PaymentResult success />} />
            <Route path="/paiement/annule" element={<PaymentResult success={false} />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
